"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCartItems = void 0;
const react_1 = require("react");
const navbar_1 = require("../context/navbar");
const helpers_1 = require("../helpers");
const coupons_1 = require("../helpers/coupons");
const types_1 = require("../types");
const cart_1 = require("../types/cart");
const useFreeProducts_1 = require("./useFreeProducts");
const useCartItems = ({ showNonApplicableFreeProducts = true, showLTOProducts = false, }) => {
    const { cartItems, appliedCoupon, ltoProducts } = (0, navbar_1.useNavbar)();
    const freeProducts = (0, useFreeProducts_1.useFreeProducts)({
        showNonApplicableFreeProducts,
    });
    const cartLineItems = (0, react_1.useMemo)(() => {
        const cartList = cartItems.map((item) => (Object.assign(Object.assign({}, item), { thumbImage: (0, helpers_1.thumbImage)(item) })));
        const { allowed } = (0, coupons_1.getCouponDiscount)(appliedCoupon, cartList);
        const freeProductLineItems = freeProducts.flatMap(({ products, allowed, message }) => products.map((p) => (Object.assign(Object.assign({}, p), { recordKey: `${p.id}-free-product`, cartItemSource: cart_1.CartItemSource.CART, qty: 1, itemKey: allowed ? `${p.id}-free` : `${p.id}-not-free`, cartItemType: allowed
                ? cart_1.CartListItemType.AUTO_FREE_PRODUCT
                : cart_1.CartListItemType.AUTO_FREE_PRODUCT_DISABLED, disableChange: true, hideRemove: true, couponMessage: message !== null && message !== void 0 ? message : null, extraQty: 0 }))));
        const ltoAddedProducts = cartList
            .filter((c) => c.cartItemSource === cart_1.CartItemSource.LIMITED_TIME_DEAL &&
            c.parentRecordKey)
            .reduce((acc, ltoP) => (Object.assign(Object.assign({}, acc), { [ltoP.parentRecordKey]: ltoP })), {});
        if (allowed && (appliedCoupon === null || appliedCoupon === void 0 ? void 0 : appliedCoupon.couponType) === types_1.CouponType.BUY_X_GET_Y) {
            const { applicableCollections, applicableProducts } = appliedCoupon;
            const { couponApplicableCartList, couponNonApplicableCartList } = cartList.reduce((acc, c) => {
                const isCartItem = !c.cartItemSource;
                const isProductApplicable = Array.isArray(applicableProducts) && applicableProducts.length
                    ? applicableProducts.includes(c.id)
                    : true;
                const isCollectionApplicable = Array.isArray(applicableCollections) &&
                    applicableCollections.length
                    ? applicableCollections.some((ac) => (c.collections || []).includes(ac))
                    : true;
                if (isCartItem && isCollectionApplicable && isProductApplicable) {
                    return Object.assign(Object.assign({}, acc), { couponApplicableCartList: [...acc.couponApplicableCartList, c] });
                }
                return Object.assign(Object.assign({}, acc), { couponNonApplicableCartList: [
                        ...acc.couponNonApplicableCartList,
                        c,
                    ] });
            }, { couponApplicableCartList: [], couponNonApplicableCartList: [] });
            const sortedItems = couponApplicableCartList.sort((a, b) => a.price > b.price ? 1 : -1);
            const getYQuantity = (0, coupons_1.getBxGyFreeQuantity)(appliedCoupon.getYQuantity, appliedCoupon.buyXQuantity, sortedItems);
            let remainingDiscount = appliedCoupon.maxDiscount || Infinity;
            const { lineItems } = sortedItems.reduce(({ remQty, lineItems }, item, index) => {
                const itemQty = Number(item.qty) || 1;
                const freeQty = remainingDiscount === Infinity
                    ? Math.min(itemQty, Math.max(0, remQty))
                    : Math.min(remainingDiscount / Number(item.price), itemQty, Math.max(0, remQty));
                const remQTY = remQty - freeQty;
                const ltoDeal = ltoAddedProducts[item.recordKey]
                    ? null
                    : ltoProducts[index];
                const ltoProduct = ltoAddedProducts[item.recordKey];
                if (!freeQty) {
                    lineItems.push(Object.assign(Object.assign({}, item), { itemKey: `${item.recordKey}-full-paid`, cartItemType: cart_1.CartListItemType.CART, extraQty: 0, disableChange: false, hideRemove: false, couponMessage: null, ltoDeal,
                        ltoProduct }));
                }
                else if (freeQty === itemQty) {
                    lineItems.push(Object.assign(Object.assign({}, item), { itemKey: `${item.recordKey}-full-item-free`, cartItemType: cart_1.CartListItemType.FREE_PRODUCT, extraQty: 0, disableChange: false, hideRemove: false, couponMessage: null, ltoDeal,
                        ltoProduct }));
                }
                else {
                    lineItems.push(Object.assign(Object.assign({}, item), { itemKey: `${item.recordKey}-${itemQty - freeQty}-partial-item-free`, cartItemType: cart_1.CartListItemType.FREE_PRODUCT, qty: freeQty, extraQty: itemQty - freeQty, disableChange: false, hideRemove: false, couponMessage: null }), Object.assign(Object.assign({}, item), { itemKey: `${item.recordKey}-${itemQty - freeQty}-partial-item-paid`, cartItemType: cart_1.CartListItemType.CART, qty: itemQty - freeQty, extraQty: freeQty, disableChange: false, hideRemove: false, couponMessage: null, ltoDeal,
                        ltoProduct }));
                }
                return { remQty: remQTY, lineItems };
            }, { remQty: getYQuantity, lineItems: [] });
            return [
                ...lineItems,
                ...couponNonApplicableCartList
                    .filter((p) => showLTOProducts ||
                    p.cartItemSource !== cart_1.CartItemSource.LIMITED_TIME_DEAL)
                    .map((p, index) => {
                    const ltoDeal = ltoAddedProducts[p.recordKey]
                        ? null
                        : ltoProducts[couponApplicableCartList.length + index];
                    const ltoProduct = ltoAddedProducts[p.recordKey];
                    return Object.assign(Object.assign({}, p), { itemKey: `${p.recordKey}-coupon-non-applicable`, cartItemType: cart_1.CartListItemType.CART, extraQty: 0, disableChange: false, hideRemove: false, couponMessage: null, ltoDeal,
                        ltoProduct });
                }),
                ...freeProductLineItems,
            ];
        }
        return [
            ...cartList
                .filter((p) => showLTOProducts ||
                p.cartItemSource !== cart_1.CartItemSource.LIMITED_TIME_DEAL)
                .map((p, index) => {
                let cartItemType = p.cartItemSource === cart_1.CartItemSource.COUPON && allowed
                    ? cart_1.CartListItemType.FREE_PRODUCT
                    : cart_1.CartListItemType.CART;
                if (p.cartItemSource !== cart_1.CartItemSource.COUPON) {
                    cartItemType = p.cartItemSource;
                }
                return Object.assign(Object.assign({}, p), { itemKey: p.recordKey, cartItemType, disableChange: false, hideRemove: false, couponMessage: null, extraQty: 0, ltoDeal: ltoAddedProducts[p.recordKey] ? null : ltoProducts[index], ltoProduct: ltoAddedProducts[p.recordKey] });
            }),
            ...freeProductLineItems,
        ];
    }, [cartItems, freeProducts, appliedCoupon]);
    return cartLineItems;
};
exports.useCartItems = useCartItems;
